(function () {
  'use strict';

  // ═══════════════════════════════════════════════════════════════════
  // Cart Drawer Upsell Fix v4 — consolidated fixes layer
  // Runs AFTER cart-magic.js (defer order).
  //
  // Fixes:
  //  1. Loading perf   — no more double fetch monkey-patch
  //  2. Gift dupe      — removed cascading refresh triggers
  //  3. Gift pricing   — un-mark items that aren't real gifts
  //  4. Coupon code    — proper validation via /cart.js verification
  //  5. Upsell carousel — unified fallback loader
  //  6. Loop Protection — breaks infinite spinner if free gift is out of stock
  // ═══════════════════════════════════════════════════════════════════

  // ─── Utilities ─────────────────────────────────────────────────────

  function formatMoney(cents) {
    if (window.GKCartDrawerPro && typeof window.GKCartDrawerPro.formatMoney === 'function') {
      return window.GKCartDrawerPro.formatMoney(cents);
    }
    var rupees = Math.round(Number(cents) || 0) / 100;
    return '\u20B9' + rupees.toLocaleString('en-IN', {
      minimumFractionDigits: rupees % 1 ? 2 : 0,
      maximumFractionDigits: 2,
    });
  }

  function moneyFromRupees(value) {
    return formatMoney(Math.round(Number(value) || 0) * 100);
  }

  function esc(v) {
    return String(v || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function fetchJson(url, opts) {
    return fetch(url, Object.assign({ credentials: 'same-origin' }, opts || {}))
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.json();
      });
  }

  // ─── Shared State ──────────────────────────────────────────────────

  var _lastCartData = null;
  var _syncTimer = null;
  var _isModifyingDom = false;

  function debouncedSync(delay) {
    clearTimeout(_syncTimer);
    _syncTimer = setTimeout(syncAll, delay || 350);
  }

  function refreshCartData(cb) {
    fetchJson('/cart.js')
      .then(function (cart) {
        _lastCartData = cart;
        if (cb) cb(cart);
      })
      .catch(function () {});
  }

  // ═══════════════════════════════════════════════════════════════════
  // FIX 1 — No double fetch monkey-patch
  //
  // BEFORE: This file patched window.fetch a SECOND time (cart-magic
  //         already patches it), causing 2x cascading refreshes on
  //         every add/remove → visible loading lag.
  // NOW:    We observe the cart-drawer DOM for changes (which happen
  //         after cart-magic's themeCartRefresh), and run our extras
  //         ONCE with a debounce. No fetch interception needed.
  // ═══════════════════════════════════════════════════════════════════

  // ═══════════════════════════════════════════════════════════════════
  // FIX 2 — Duplicate gift-strip fix
  // ═══════════════════════════════════════════════════════════════════

  function hideDuplicateFreeGiftStrip() {
    var source = document.getElementById('gk-magic-blocks-source');
    var strip = document.querySelector('#gk-bottom-blocks-slot #gk-free-gift-strip');
    if (source && strip && strip.parentElement !== source) {
      source.appendChild(strip);
    }
  }

  // ═══════════════════════════════════════════════════════════════════
  // FIX 3 — Gift pricing correction
  //
  // cart-magic.js FreeGiftCartUI.apply() marks ALL DOM elements whose
  // xo-product-id matches a gift's variant_id. If the same product
  // exists as both a paid item and an auto-gift, the paid one also
  // gets the "FREE!" label. We fix by checking data-line-key against
  // the actual cart item properties.
  // ═══════════════════════════════════════════════════════════════════

  function fixGiftPricing() {
    if (!_lastCartData || !_lastCartData.items) return;

    // Build map: lineKey → cartItem
    var keyMap = {};
    _lastCartData.items.forEach(function (item) {
      keyMap[item.key] = item;
    });

    _isModifyingDom = true;

    document.querySelectorAll('.xo-cart-mini-item').forEach(function (el) {
      var lineKey = el.dataset.lineKey || '';
      var cartItem = keyMap[lineKey];
      if (!cartItem) return;

      var isRealGift = (cartItem.properties || {})._is_free_gift === 'true';
      var isMarkedFree = el.classList.contains('gk-is-free-item') ||
                         el.dataset.gkGiftMarked === '1';

      // Item was incorrectly marked as free → revert to paid display
      if (isMarkedFree && !isRealGift) {
        el.classList.remove('gk-is-free-item');
        delete el.dataset.gkGiftMarked;

        // Restore correct price
        var priceEl = el.querySelector('.xo-cart-mini-item__price');
        if (priceEl) {
          var freeLabel = priceEl.querySelector(
            '.xo-cart-mini-item__free-price, .gk-free-item-badge'
          );
          if (freeLabel) {
            var linePrice = cartItem.final_line_price;
            var comparePrice = cartItem.original_line_price;

            if (comparePrice > linePrice) {
              priceEl.innerHTML =
                '<div class="xo-cart-mini-item__discounted-prices">' +
                  '<span class="xo-cart-mini-item__final-price">' +
                    formatMoney(linePrice) +
                  '</span>' +
                  '<s class="xo-cart-mini-item__original-price xo-cart-mini-item__original-price--old">' +
                    formatMoney(comparePrice) +
                  '</s>' +
                '</div>';
            } else {
              priceEl.innerHTML =
                '<div class="xo-cart-mini-item__original-price">' +
                  formatMoney(linePrice) +
                '</div>';
            }
          }
        }

        // Re-enable quantity controls
        el.querySelectorAll(
          '.xo-cart-mini-item__quatity-remove button, ' +
          '.xo-cart-mini-item__quatity-remove input'
        ).forEach(function (ctrl) {
          ctrl.disabled = false;
          if (ctrl.tagName === 'INPUT') ctrl.readOnly = false;
        });

        // Show remove button
        var rem = el.querySelector('.xo-cart-mini-item__remove');
        if (rem) rem.style.display = '';

        // Remove gift icon
        var gIcon = el.querySelector('.gk-gift-icon');
        if (gIcon) gIcon.remove();
      }
    });

    _isModifyingDom = false;
  }

  // ═══════════════════════════════════════════════════════════════════
  // FIX 4 — Coupon code validation
  //
  // BEFORE: GET /discount/{code} always "succeeded" (redirect-based,
  //         no error differentiation). Invalid codes showed "applied".
  // NOW:    After applying, we fetch /cart.js and verify the discount
  //         actually appears in cart data. If not → show error and
  //         clear the invalid discount.
  // ═══════════════════════════════════════════════════════════════════

  function showCouponMsg(wrapper, text, type) {
    var old = wrapper.querySelector('.gk-coupon-msg');
    if (old) old.remove();

    var el = document.createElement('div');
    el.className = 'gk-coupon-msg gk-coupon-msg--' + type;
    el.style.cssText =
      'font-size:12px;padding:6px 0 0 0;display:flex;align-items:center;gap:6px;' +
      (type === 'error' ? 'color:#e74c3c;' : 'color:#27ae60;');
    
    var iconSvg = type === 'error'
      ? '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>'
      : '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>';

    el.innerHTML = iconSvg + '<span>' + text + '</span>';
    wrapper.appendChild(el);

    if (type === 'success') {
      setTimeout(function () {
        if (el.parentNode) el.remove();
      }, 5000);
    }
  }

  function applyInlineCoupon(trigger) {
    var wrapper =
      trigger && trigger.closest && trigger.closest('.gk-cart-coupon-inline');
    if (!wrapper || wrapper.classList.contains('is-applying')) return;

    var input = wrapper.querySelector('input[name="discount"], input');
    var code = (input && input.value) ? input.value.trim() : '';

    // Clear previous state
    wrapper.classList.remove('has-error', 'is-applied');
    var oldMsg = wrapper.querySelector('.gk-coupon-msg');
    if (oldMsg) oldMsg.remove();

    if (!code) {
      wrapper.classList.add('has-error');
      showCouponMsg(wrapper, 'Please enter a coupon code', 'error');
      if (input) input.focus();
      return;
    }

    wrapper.classList.add('is-applying');

    // Step 1 — capture current discount total
    var discountBefore = 0;
    fetchJson('/cart.js')
      .then(function (cart) {
        discountBefore = cart.total_discount || 0;

        // Step 2 — apply discount via Shopify's redirect URL
        return fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart', {
          method: 'GET',
          credentials: 'same-origin',
          redirect: 'follow',
        });
      })
      .then(function () {
        // Step 3 — wait for Shopify to process
        return new Promise(function (res) { setTimeout(res, 600); });
      })
      .then(function () {
        // Step 4 — verify discount was actually applied
        return fetchJson('/cart.js');
      })
      .then(function (cart) {
        _lastCartData = cart;
        var applied = false;
        var upperCode = code.toUpperCase();

        // Check if total_discount increased
        if ((cart.total_discount || 0) > discountBefore) {
          applied = true;
        }

        // Check cart-level discount applications
        (cart.cart_level_discount_applications || []).forEach(function (d) {
          if (d.title && d.title.toUpperCase() === upperCode) applied = true;
        });

        // Check line-item discounts
        (cart.items || []).forEach(function (item) {
          (item.discounts || []).forEach(function (d) {
            if (d.title && d.title.toUpperCase() === upperCode) applied = true;
          });
        });

        if (applied) {
          wrapper.classList.add('is-applied');
          showCouponMsg(wrapper, 'Coupon applied successfully!', 'success');
          if (input) input.disabled = true;

          // Refresh cart drawer to show updated prices
          if (window.GKCartDrawerPro && window.GKCartDrawerPro.refresh) {
            window.GKCartDrawerPro.refresh();
          }
        } else {
          wrapper.classList.add('has-error');
          showCouponMsg(wrapper, 'Invalid or expired coupon code', 'error');

          // Clear the invalid discount
          fetch('/discount/clear?redirect=/cart', {
            method: 'GET',
            credentials: 'same-origin',
            redirect: 'follow',
          }).catch(function () {});
        }
      })
      .catch(function () {
        wrapper.classList.add('has-error');
        showCouponMsg(wrapper, 'Unable to apply coupon. Try again.', 'error');
      })
      .then(function () {
        wrapper.classList.remove('is-applying');
      });
  }

  function bindCoupon() {
    if (window.__gkCouponBound) return;
    window.__gkCouponBound = true;

    document.addEventListener(
      'click',
      function (e) {
        var btn =
          e.target.closest &&
          e.target.closest(
            '.gk-cart-coupon-inline__submit, .gk-cart-coupon-inline__button'
          );
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        applyInlineCoupon(btn);
      },
      true
    );

    document.addEventListener(
      'keydown',
      function (e) {
        if (e.key !== 'Enter') return;
        var inp =
          e.target.closest &&
          e.target.closest('.gk-cart-coupon-inline input');
        if (!inp) return;
        e.preventDefault();
        e.stopPropagation();
        applyInlineCoupon(inp);
      },
      true
    );
  }

  // ═══════════════════════════════════════════════════════════════════
  // FIX 5 — Upsell / "May Also Like" carousel
  //
  // Only fills if cart-magic.js's Upsell module didn't populate the
  // carousel. Uses /collections/all/products.json as fallback source.
  // Throttled to prevent rapid re-fetching.
  // ═══════════════════════════════════════════════════════════════════

  var _upsellBusy = false;
  var _upsellCache = null;
  var _lastUpsellAt = 0;
  var _lastUpsellCartSig = '';
  var _fillUpsellTimer = null;

  function getUpsellCartSig(cartIds) {
    return (cartIds || []).slice().sort(function (a, b) { return a - b; }).join(',');
  }

  function getRenderedUpsellSig(carousel) {
    if (!carousel) return '';
    return Array.prototype.map.call(
      carousel.querySelectorAll('.gk-upsell__item'),
      function (el) { return el.dataset.variantId || ''; }
    ).join(',');
  }

  /** Debounced entry — coalesces MO + cart events + syncAll into one run. */
  function scheduleFillUpsell(force, delay) {
    clearTimeout(_fillUpsellTimer);
    _fillUpsellTimer = setTimeout(function () {
      fillUpsell(!!force);
    }, typeof delay === 'number' ? delay : 180);
  }

  function withUpsellDomLock(fn) {
    _isModifyingDom = true;
    try { fn(); } finally {
      setTimeout(function () { _isModifyingDom = false; }, 0);
    }
  }

  function getCartProductIds() {
    return fetchJson('/cart.js')
      .then(function (cart) {
        _lastCartData = cart;
        return (cart.items || [])
          .filter(function (i) {
            var p = i.properties || {};
            return p._is_free_gift !== 'true' && p._is_one_tick !== 'true';
          })
          .map(function (i) { return Number(i.product_id); })
          .filter(Boolean);
      })
      .catch(function () { return []; });
  }

  function pickProducts(all, cartIds, limit) {
    var set = {};
    cartIds.forEach(function (id) { set[id] = true; });
    return (all || [])
      .filter(function (p) {
        return p && p.variants && p.variants.length && !set[Number(p.id)];
      })
      .slice(0, limit);
  }

  function prodImg(p) {
    if (p.featured_image) {
      return typeof p.featured_image === 'string'
        ? p.featured_image
        : p.featured_image.src;
    }
    return p.images && p.images[0] ? (p.images[0].src || p.images[0]) : '';
  }

  function renderUpsell(products) {
    var wrap = document.getElementById('gk-cart-upsell');
    var carousel = document.getElementById('gk-upsell-carousel');
    var loader = document.getElementById('gk-upsell-loading');
    if (!wrap || !carousel) return;

    withUpsellDomLock(function () {
      if (!products.length) {
        if (loader) loader.style.display = 'none';
        carousel.innerHTML = '';
        wrap.setAttribute('data-state', 'empty');
        wrap.setAttribute('hidden', '');
        wrap.style.display = 'none';
        return;
      }

      carousel.innerHTML = products
        .map(function (p) {
          var v = p.variants[0];
          var price = Number(v.price || 0);
          var cmp = Number(v.compare_at_price || 0);
          var hasCmp = cmp > price;
          var img = prodImg(p);

          var imgH = img
            ? '<img class="gk-upsell__img" src="' + esc(img) +
              '" alt="' + esc(p.title) +
              '" loading="lazy" width="84" height="84">'
            : '<div class="gk-upsell__img gk-upsell__img--placeholder"></div>';

          var prH = hasCmp
            ? '<s class="gk-upsell__compare">' + moneyFromRupees(cmp) +
              '</s><span class="gk-upsell__price">' + moneyFromRupees(price) +
              '</span>'
            : '<span class="gk-upsell__price">' + moneyFromRupees(price) +
              '</span>';

          return (
            '<div class="gk-upsell__item" data-variant-id="' + esc(v.id) + '">' +
              '<div class="gk-upsell__img-wrap">' + imgH + '</div>' +
              '<div class="gk-upsell__body">' +
                '<div class="gk-upsell__title">' + esc(p.title) + '</div>' +
                '<div class="gk-upsell__price-row">' + prH + '</div>' +
                '<button class="gk-upsell__add" type="button">+ ADD</button>' +
              '</div>' +
            '</div>'
          );
        })
        .join('');

      wrap.removeAttribute('hidden');
      wrap.style.display = '';
      wrap.setAttribute('data-state', 'ready');
      hideUpsellLoader();
    });
  }

  function hideUpsellLoader() {
    var loader = document.getElementById('gk-upsell-loading');
    if (!loader) return;
    loader.style.display = 'none';
    loader.setAttribute('aria-hidden', 'true');
  }

  /**
   * One document-level delegated handler for upsell nav + ADD buttons.
   * Survives innerHTML swaps from themeCartRefresh / placeBlocksFromSource
   * (per-button listeners + data-bound were lost after HTML copy).
   */
  function initUpsellDelegation() {
    if (window.__gkUpsellDelegated) return;
    window.__gkUpsellDelegated = true;

    document.addEventListener('click', function (e) {
      var wrap = document.getElementById('gk-cart-upsell');
      if (!wrap || wrap.getAttribute('data-state') !== 'ready') return;

      var carousel = document.getElementById('gk-upsell-carousel');
      if (!carousel) return;

      var prevBtn = e.target.closest && e.target.closest('#gk-cart-upsell .gk-upsell-prev');
      if (prevBtn) {
        e.preventDefault();
        carousel.scrollBy({ left: -(carousel.clientWidth - 40), behavior: 'smooth' });
        return;
      }

      var nextBtn = e.target.closest && e.target.closest('#gk-cart-upsell .gk-upsell-next');
      if (nextBtn) {
        e.preventDefault();
        carousel.scrollBy({ left: carousel.clientWidth - 40, behavior: 'smooth' });
        return;
      }

      var btn = e.target.closest && e.target.closest('#gk-cart-upsell .gk-upsell__add');
      if (!btn || btn.disabled) return;

      var item = btn.closest('.gk-upsell__item');
      var vid = item && item.dataset.variantId;
      if (!vid) return;

      btn.disabled = true;
      btn.classList.add('is-loading');
      btn.textContent = '\u2026';

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] }),
      })
        .then(function (r) {
          if (!r.ok) throw new Error();
          btn.classList.remove('is-loading');
          btn.textContent = '\u2713 ADDED';
          try {
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          } catch (err) {}
          scheduleFillUpsell(true, 750);
        })
        .catch(function () {
          btn.disabled = false;
          btn.classList.remove('is-loading');
          btn.textContent = '+ ADD';
        });
    });
  }

  function bindUpsellBtns(carousel) {
    hideUpsellLoader();
  }

  function fillUpsell(force) {
    var wrap = document.getElementById('gk-cart-upsell');
    var carousel = document.getElementById('gk-upsell-carousel');
    if (!wrap || !carousel) return;
    if (_upsellBusy) return;

    var hasContent = !!carousel.querySelector('.gk-upsell__item');
    var isReady = wrap.getAttribute('data-state') === 'ready';

    // Skip if carousel already populated and we're not forcing a cart-driven
    // refresh (force is only needed when cart product ids may have changed).
    if (!force && hasContent && isReady) {
      bindUpsellBtns(carousel);
      return;
    }

    if (!force) {
      if (Date.now() - _lastUpsellAt < 2000) return;
      _lastUpsellAt = Date.now();
    }

    _upsellBusy = true;

    // Only enter loading (hidden) on the very first paint — never flash-hide
    // an already-visible carousel during background refreshes.
    if (!hasContent && !isReady) {
      wrap.setAttribute('data-state', 'loading');
      wrap.setAttribute('hidden', '');
    }

    var limit = Number(wrap.dataset.limit || 6) || 6;

    var productPromise = _upsellCache
      ? Promise.resolve(_upsellCache)
      : fetchJson('/collections/all/products.json?limit=' + Math.max(limit + 6, 12))
          .then(function (d) {
            _upsellCache = d.products || [];
            return _upsellCache;
          });

    Promise.all([productPromise, getCartProductIds()])
      .then(function (r) {
        wrap = document.getElementById('gk-cart-upsell');
        carousel = document.getElementById('gk-upsell-carousel');
        if (!wrap || !carousel) return;

        var hasContentNow = !!carousel.querySelector('.gk-upsell__item');
        var isReadyNow = wrap.getAttribute('data-state') === 'ready';
        var cartIds = r[1];
        var cartSig = getUpsellCartSig(cartIds);
        var picked = pickProducts(r[0], cartIds, limit);
        var pickedSig = picked.map(function (p) {
          return String(p.variants[0].id);
        }).join(',');
        var currentSig = getRenderedUpsellSig(carousel);

        // Nothing changed — keep the visible carousel as-is (no flicker).
        if (cartSig === _lastUpsellCartSig && pickedSig === currentSig && isReadyNow && hasContentNow) {
          hideUpsellLoader();
          return;
        }

        _lastUpsellCartSig = cartSig;

        if (pickedSig === currentSig && picked.length && isReadyNow) {
          hideUpsellLoader();
          return;
        }

        renderUpsell(picked);
      })
      .catch(function () {})
      .then(function () { _upsellBusy = false; });
  }

  // ─── Checkout (Shopflo integration) ────────────────────────────────

  function closeDrawer() {
    var btn = document.querySelector('.xo-modal-content-style1__close');
    if (btn) btn.click();
  }

  function goCheckout() {
    closeDrawer();
    if (typeof window.handleFloCheckoutBtn === 'function') {
      window.handleFloCheckoutBtn();
      return;
    }
    window.location.href = '/checkout';
  }

  function patchCheckout() {
    // Do NOT override window.handleFloCheckout — the inline script in theme.liquid
    // has the most robust version with Shopflo wait logic and button loading state.
    if (window.__gkCheckoutBound) return;
    window.__gkCheckoutBound = true;

    document.addEventListener(
      'click',
      function (e) {
        var btn =
          e.target.closest &&
          e.target.closest('#checkout2');
        if (!btn || btn.disabled || btn.classList.contains('disabled')) return;
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        if (typeof window.handleFloCheckout === 'function') {
          window.handleFloCheckout(e);
        } else {
          goCheckout();
        }
      },
      true
    );
  }

  // ═══════════════════════════════════════════════════════════════════
  // Sync All — single debounced entry point for extras
  // ═══════════════════════════════════════════════════════════════════

  function syncAll() {
    hideDuplicateFreeGiftStrip();
    moveSavingsBar();
    scheduleFillUpsell(false, 200);
    refreshCartData(function (cart) {
      fixGiftPricing();
      updateSavingsText();
    });
  }

  function moveSavingsBar() {
    var source = document.getElementById('gk-magic-blocks-source');
    var savings = document.querySelector('#gk-savings-bar');
    var footerSlot = document.getElementById('gk-footer-blocks-slot');
    if (savings && footerSlot && savings.parentElement !== footerSlot) {
      footerSlot.appendChild(savings);
    }
  }

  function updateSavingsText() {
    var bar = document.getElementById('gk-savings-bar');
    if (!bar) return;

    if (!_lastCartData || !_lastCartData.items) return;

    var totalSavings = 0;
    var originalTotal = 0;

    // Read compare-at prices from DOM elements (since standard cart.js does not expose compare_at_price)
    var domItems = {};
    document.querySelectorAll('.xo-cart-mini-item').forEach(function (el) {
      var lineKey = el.dataset.lineKey;
      var compareAt = Number(el.dataset.compareAtPriceCents);
      if (lineKey && !isNaN(compareAt)) {
        domItems[lineKey] = compareAt;
      }
    });

    _lastCartData.items.forEach(function (item) {
      var qty = Number(item.quantity) || 1;
      var unitFinal = Number(item.final_price);
      if (isNaN(unitFinal)) unitFinal = Number(item.price) || 0;
      var itemFinalLine = Number(item.final_line_price);
      if (isNaN(itemFinalLine)) itemFinalLine = unitFinal * qty;

      var unitCompareAt = domItems[item.key];
      if (unitCompareAt === undefined || isNaN(unitCompareAt)) {
        unitCompareAt = Number(item.original_price);
      }
      if (isNaN(unitCompareAt) || unitCompareAt <= 0) {
        unitCompareAt = unitFinal;
      }

      if (unitCompareAt > unitFinal) {
        var itemSaving = (unitCompareAt - unitFinal) * qty;
        totalSavings += itemSaving;
        originalTotal += unitCompareAt * qty;
      } else {
        // Match Liquid footer fallback: use original_line_price when no compare-at discount
        var fallbackLine = Number(item.original_line_price);
        if (isNaN(fallbackLine)) fallbackLine = itemFinalLine;
        originalTotal += fallbackLine;
      }
    });

    if (_lastCartData.cart_level_discount_applications) {
      _lastCartData.cart_level_discount_applications.forEach(function (d) {
        totalSavings += Number(d.total_allocated_amount || 0);
      });
    }

    if (totalSavings > 0) {
      if (originalTotal <= 0) {
        originalTotal = _lastCartData.total_price + totalSavings;
      }

      var pct = Math.round((totalSavings / originalTotal) * 100);
      if (isNaN(pct) || pct <= 0) pct = 0;

      var savingsFormatted = formatMoneyCents(totalSavings);

      var prefixEl = bar.querySelector('.gk-savings__prefix');
      var amountEl = bar.querySelector('.gk-savings__amount');

      if (prefixEl) {
        prefixEl.innerHTML = 'You Saved <strong>' + savingsFormatted + ' (' + pct + '%)</strong> so far!';
      }
      if (amountEl) {
        amountEl.textContent = '';
      }

      bar.style.setProperty('display', 'flex', 'important');
    } else {
      bar.style.setProperty('display', 'none', 'important');
    }
  }

  /**
   * Format Shopify cents as a money string matching the storefront's currency.
   * Reads the rendered footer value to detect prefix/symbol and uses
   * Intl.NumberFormat for grouped integer output. Falls back to "Rs. X,XXX".
   */
  function formatMoneyCents(cents) {
    var amount = Math.round(Number(cents) || 0);
    var rupees = Math.round(amount / 100);
    var grouped;
    try {
      grouped = rupees.toLocaleString('en-IN');
    } catch (e) {
      grouped = String(rupees);
    }

    // Try to detect the storefront's money prefix from an existing formatted node
    var sample = document.querySelector('[data-cart-subtotal-price], .gk-price-accordion-header [style*="font-weight: 700"]');
    var prefix = 'Rs. ';
    if (sample && sample.textContent) {
      var m = sample.textContent.match(/^(\D+)\s*[\d,]/);
      if (m && m[1]) prefix = m[1].trim() + (m[1].trim().slice(-1) === '.' ? ' ' : ' ');
    }
    return prefix + grouped;
  }

  // ═══════════════════════════════════════════════════════════════════
  // Loop Protection (Fix 6)
  // ═══════════════════════════════════════════════════════════════════

  var _activeCartPromise = Promise.resolve();

  function disableCartControls(disabled) {
    document.querySelectorAll(
      '.xo-quantity-style2__button, ' +
      'input[name="quantity"], ' +
      '.xo-cart-mini-item__remove-action, ' +
      '.gk-checkout-btn, ' +
      '.gk-viewcart-btn'
    ).forEach(function (el) {
      if (disabled) {
        el.setAttribute('disabled', 'true');
        el.style.pointerEvents = 'none';
        el.style.opacity = '0.6';
      } else {
        el.removeAttribute('disabled');
        el.style.pointerEvents = '';
        el.style.opacity = '';
      }
    });

    var overlay = document.getElementById("gk-cart-loading-overlay");
    if (overlay) {
      if (disabled) {
        overlay.classList.add("is-active");
      } else {
        overlay.classList.remove("is-active");
      }
    }
  }

  function protectGiftLoops() {
    // NOTE: The global sequential cart queue is now installed in layout/theme.liquid <head>
    // BEFORE any other scripts load. That interceptor handles sequencing, gift loop protection,
    // and badge syncing for ALL scripts including xo-webcomponents.min.js.
    // We expose the original native fetch for internal use (e.g. merge without re-queueing).
    if (window.__gkGiftProtector) return;
    window.__gkGiftProtector = true;
    // Store reference to the true native fetch (captured before any patches) for internal use
    window._gkNativeFetch = window._gkNativeFetch || fetch;
  }

  // ═══════════════════════════════════════════════════════════════════
  // Init
  // ═══════════════════════════════════════════════════════════════════

  function init() {
    protectGiftLoops();
    initUpsellDelegation();
    patchCheckout();
    bindCoupon();

    syncAll();

    // Watch cart ITEMS only — not the upsell carousel. Observing the full
    // drawer subtree caused a feedback loop: fillUpsell writes carousel HTML
    // → MO fires → syncAll → fillUpsell → loading hide/show flicker.
    var mo = new MutationObserver(function () {
      if (_isModifyingDom) return;
      debouncedSync(500);
    });

    function observeCart() {
      var el = document.querySelector('[xo-unique-id="xo-cart-mini-content"]');
      if (el && !el.dataset.gkUpsellMoBound) {
        el.dataset.gkUpsellMoBound = 'true';
        mo.observe(el, { childList: true, subtree: true });
      }
    }
    observeCart();

    new MutationObserver(observeCart).observe(document.body, {
      childList: true,
    });

    // Single debounced upsell refresh on cart mutations (not per-MO from upsell).
    var cartEvents = [
      'cart:change', 'cart:updated', 'cart:add', 'cart:remove',
      'xo:cart:updated', 'theme:cart:updated', 'ajax-cart:render'
    ];
    cartEvents.forEach(function (name) {
      document.addEventListener(name, function () {
        scheduleFillUpsell(true, 400);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
